<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useForm } from 'vee-validate';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import * as yup from '@/helpers/yup-distilled';
import { useAuthStore } from '@/stores';
import { router, getNextRouteFromNewSigninState } from '@/helpers';
import { getFriendlyErrorMessage } from '@/helpers';

const schema = yup.object().shape({
	username: yup.string().required('Username is required')
});

const { defineField, errors, isSubmitting, handleSubmit } = useForm({
	validationSchema: schema
});

const route = useRoute();
const authStore = useAuthStore();
const [username] = defineField('username');

const onSubmit = handleSubmit((values, { setErrors }) => {
	const { username } = values;

	authStore.setLoginForResetPasswordByPasscode(username);

	return authStore
		.requestPasscodeForPasswordReset(username)
		.then(async () => {
			router.push(
				getNextRouteFromNewSigninState(authStore.signInState, route)
			);
		})
		.catch(async (error) => {
			const errorOutput = await getFriendlyErrorMessage(error);
			setErrors({ apiError: errorOutput.message });
		});
});
</script>
<template>
	<form @submit="onSubmit">
		<div class="p-field mt-4 mb-4">
			Please enter your username. A one-time passcode will be sent by
			email and/or text message, which will be used to complete your
			password setup.
		</div>
		<div class="p-fluid login-small-form">
			<div class="p-field mt-2">
				<label class="font-semibold" for="username">Username</label>
				<InputText
					autocomplete="username"
					autofocus
					v-model="username"
					type="text"
					:invalid="!!errors.username"
				/>
				<div class="p-error">{{ errors.username }}&nbsp;</div>
			</div>
		</div>
		<div class="p-fluid">
			<Button
				:disabled="isSubmitting"
				label="Submit"
				type="submit"
			></Button>
			<div v-if="errors.apiError" class="p-error">
				{{ errors.apiError }}
			</div>
		</div>
	</form>
</template>
